import style from './TreeDrawerToolbar.module.css';

import searchSVG from 'assets/svg/serch-01.svg';
import refreshIcon from 'assets/svg/refresh-01.svg';

import React, { useContext, useEffect, useState } from 'react';
import { getListTypeStorages } from '../../../services/list.services';
import { observer } from 'mobx-react-lite';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import { modeContext } from 'components/Contexts/contexts';
import classNames from 'classnames';
import { treeStore } from 'store/mobx/tree.store';
import Tooltip from 'ui/Tooltip';
import IconButton from 'ui/IconButton';
import ModalPackSelect from 'components/Packs/ModalPackSelect/ModalPackSelect';
import ModalPackAdd from 'components/Packs/ModalPackAdd/ModalPackAdd';
import { setPackToStorage } from 'services/pucks.services';
import useAlert from 'hooks/useAlert';
import ManageStorageModal from 'components/Tabs/StorageTabPage/ManageStorageModal';

const TreeDrawerToolbar = observer(() => {
  const { refresh, setQueryString, selectedNode } = treeStore;
  const { mode } = useContext(modeContext);

  const { showAlert } = useAlert();

  const [struct, setStruct] = useState({
    favorite: true,
    search: true,
    add: true,
    add_text: 'Добавить',
    add_plus: true,
    copy: true,
    print: false,
  });

  const [listAdd, setListAdd] = useState([
    {
      id: 1,
      name: 'Локация',
      icon: 'icons/location-01.svg',
      parent: 1,
      level: '1',
      parameters: {},
    },
    {
      id: 2,
      name: 'Холодильник',
      icon: 'icons/fridge.svg',
      parent: 2,
      level: '2',
      parameters: {},
    },
    {
      id: 3,
      name: 'Полка',
      icon: 'icons/shelf-01.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 4,
      name: 'Рэк',
      icon: 'icons/rec-02.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 5,
      name: 'Штатив',
      icon: 'icons/pack.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 6,
      name: 'Свободный элемент',
      icon: 'icons/free-item.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 7,
      name: 'Морозильная камера',
      icon: 'icons/freezer.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 8,
      name: 'Ящик',
      icon: 'icons/tripod-01.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 9,
      name: 'Выдвижной ящик',
      icon: 'icons/sliding_shelf-01.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 10,
      name: 'Криохранилище',
      icon: 'icons/cryostorage.svg',
      parent: 2,
      level: '2',
      parameters: {},
    },
    {
      id: 11,
      name: 'Сосуд Дьюара',
      icon: 'icons/vessel.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 12,
      name: 'Выдвижная полка',
      icon: 'icons/sliding_shelf-02.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 13,
      name: 'Стойка',
      icon: 'icons/stand.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 14,
      name: 'Канистра',
      icon: 'icons/canister.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 15,
      name: 'Штатив-держатель',
      icon: 'icons/pack-holder.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
    {
      id: 16,
      name: 'Уровень',
      icon: 'icons/rec-01.svg',
      parent: 0,
      level: '0',
      parameters: {},
    },
  ]);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [search, setSearch] = useState('');
  const [favorite, setFavorite] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    item: null,
  });

  const rules = mode.rules;
  const { storage } = rules ?? {};

  useEffect(() => {
    getStorageTypeT();
  }, []);

  useEffect(() => {
    setStruct({
      favorite: storage?.upsert_favorites,
      search: true,
      add: storage?.upsert,
      add_text: 'Добавить',
      add_plus: storage?.upsert,
      copy: storage?.upsert,
      print: false,
    });
  }, [mode]);

  useEffect(() => {
    let queryString = '?';

    if (search) queryString += `search=${search}&`;
    if (favorite) queryString += `favorites=true`;

    setQueryString(queryString);
    refresh();
  }, [search, favorite]);

  const getStorageTypeT = async () => {
    // const res = await getListTypeStorages();
    // setListAdd(res);
  };

  const addButton = () => {
    if (selectedNode?.entity !== 'storage_pack' || !selectedNode) setOpenDropdown(!openDropdown);
  };

  const savePackToStorage = async (data) => {
    let res = await setPackToStorage(data);

    if (res.success) {
      mode.setPuckSelectModal(false);
      refresh();
    } else {
      showAlert(res.error_code, 'error');
      mode.setPuckSelectModal(false);
    }
  };

  const createHandler = (item) => {
    setModal({
      open: true,
      item: {
        type: item.id,
        icon: item.icon,
        level: item.level,
        location: { parent: selectedNode?.id, path: selectedNode?.path },
      },
    });
  };

  const copy = async () => {
    // let res = await getStorage(selectedNode.id);
    // let type = listAdd.find((i) => i.id === res.type);
    // let storage = {
    //   name: res.name + '__копия',
    //   id: 0,
    //   barcodes: [],
    //   packs: [
    //     {
    //       id: null,
    //       type: 0,
    //     },
    //   ],
    //   comment: res.comment,
    //   icon: res.icon?.file ?? '',
    //   location: { parent: res.location.parent, path: getPath(res.id) },
    //   color: res.color,
    //   type: type.id,
    //   parentType: type,
    // };
    // setSelectedStorage(storage);
    // mode.setType({ mode: 'edit', item: storage });
  };

  return (
    <div className={style.WorkLeftHeader}>
      {struct.favorite && favorite && (
        <Tooltip text={'Показать избранное'}>
          <img
            className={style.WorkLeftHeader_favorite}
            alt={'favorite'}
            src={'/svg/star-01.svg'}
            onClick={() => setFavorite(false)}
          />
        </Tooltip>
      )}

      {struct.favorite && !favorite && (
        <Tooltip text={'Показать избранное'}>
          <img
            className={style.WorkLeftHeader_favorite}
            alt={'favorite'}
            src={'/svg/star2-01.svg'}
            onClick={() => setFavorite(true)}
          />
        </Tooltip>
      )}
      {struct.search && (
        <div className={style.WorkLeftHeader_search}>
          <img className={style.WorkLeftHeader_search_svg} src={searchSVG} alt={'search'} />
          <input
            className={style.WorkLeftHeader_search_input}
            placeholder={'Отобрать'}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      )}
      {struct.add && (
        <div
          className={classNames(style.WorkLeftHeader_add, {
            [style.WorkLeftHeader_add_disabled]: selectedNode?.entity === 'storage_pack',
          })}
          onClick={addButton}
        >
          <Tooltip text={'Добавить хранилище'}>{struct.add_text}</Tooltip>

          {struct.add_plus && <div className={style.WorkLeftHeader_add_plus}></div>}
          {struct.add_plus && openDropdown && (
            <>
              <div className={style.DropdownBlock} onClick={() => setOpenDropdown(false)}></div>
              <div className={style.WorkLeftHeader_add_plus_Dropdown}>
                {listAdd.map((item) => {
                  if (item.name == 'Штатив') {
                    return (
                      <div
                        key={item.id}
                        onClick={(e) => {
                          mode.setPuckSelectModal(true);
                          mode.setType({ mode: 'view', item: selectedNode });
                          e.stopPropagation();
                          setOpenDropdown(!openDropdown);
                        }}
                        className={style.WorkLeftHeader_add_plus_Dropdown_item}
                      >
                        <img
                          src={`${address_server_short}${PUBLIC_ASSETS}${item.icon}`}
                          alt={item.name}
                        />
                        <span>{item.name} </span>
                      </div>
                    );
                  } else if (item.name != 'Штатив') {
                    return (
                      <div
                        key={item.id}
                        className={style.WorkLeftHeader_add_plus_Dropdown_item}
                        onClick={() => {
                          setOpenDropdown(!openDropdown);
                          createHandler(item);
                        }}
                      >
                        <img
                          src={`${address_server_short}${PUBLIC_ASSETS}${item.icon}`}
                          alt={item.name}
                        />
                        <span>{item.name} </span>
                      </div>
                    );
                  }
                })}
              </div>
            </>
          )}
        </div>
      )}
      <IconButton tooltip={'Обновить'} variant={'flat'} icon={refreshIcon} onClick={refresh} />

      {struct.copy && (
        <Tooltip text={'Копировать'}>
          <img
            className={style.WorkLeftHeader_copy}
            alt={'copy'}
            src={'/svg/copy-01.svg'}
            onClick={copy}
          />
        </Tooltip>
      )}

      {mode.puckAddModal && rules?.storage?.upsert && (
        <ModalPackAdd
          onClose={() => mode.setPuckAddModal(false)}
          openModal={mode.puckAddModal}
          packData={{ id: 0, name: '', column: 0, lines: 0, column_name: '', lines_name: '' }}
        />
      )}
      {mode.puckSelectModal && rules?.storage?.upsert && (
        <ModalPackSelect
          mode={mode}
          action={savePackToStorage}
          onClose={() => mode.setPuckSelectModal(false)}
          openModal={mode.puckSelectModal}
          storageId={selectedNode?.id}
        />
      )}

      {modal.open && <ManageStorageModal open={modal.open} onClose={setModal} data={modal.item} />}
    </div>
  );
});

export default TreeDrawerToolbar;
